import {FC} from 'react'
import {useTranslation} from '@/translations/i18n'
import {MailHistoryView} from '@/features/mailer/hooks/useMailHistorySearchParams'
import {StyledMailerTabs, StyledMailerTabButton} from './style'

interface MailerTabsProps {
    view: MailHistoryView
    onChange: (view: MailHistoryView) => void
}

export const MailerTabs: FC<MailerTabsProps> = ({view, onChange}) => {
    const {t} = useTranslation()

    return (
        <StyledMailerTabs role="tablist">
            <StyledMailerTabButton
                type="button"
                role="tab"
                aria-selected={view === 'compose'}
                $active={view === 'compose'}
                onClick={() => onChange('compose')}
            >
                {t('mailer:tab_compose')}
            </StyledMailerTabButton>
            <StyledMailerTabButton
                type="button"
                role="tab"
                aria-selected={view === 'history'}
                $active={view === 'history'}
                onClick={() => onChange('history')}
            >
                {t('mailer:tab_history')}
            </StyledMailerTabButton>
        </StyledMailerTabs>
    )
}
